/* PrintFlow Track Order — Shopify page version.
   Config (set by the section before this script loads):
   window.PRINTFLOW_API, window.PRINTFLOW_SHOP_NAME, window.PRINTFLOW_CONTACT, window.PRINTFLOW_QUOTE_URL */

(function () {
'use strict';

window.PRINTFLOW_API       = window.PRINTFLOW_API       || 'https://technoprintflow-backend-production.up.railway.app';
window.PRINTFLOW_SHOP_NAME = window.PRINTFLOW_SHOP_NAME || 'TechnoPrints';
window.PRINTFLOW_CONTACT   = window.PRINTFLOW_CONTACT   || 'contact@technoprints.ca';
window.PRINTFLOW_QUOTE_URL = window.PRINTFLOW_QUOTE_URL || '/pages/instant-quote';

// ── Status config ────────────────────────────────────────────────────────────
const STATUS_STEPS = [
  { key: 'pending_review',  label: 'Received',      icon: '📥' },
  { key: 'file_approved',   label: 'Approved',       icon: '✓' },
  { key: 'printing',        label: 'Printing',       icon: '🖨️' },
  { key: 'post_processing', label: 'Finishing',      icon: '✂️' },
  { key: 'fulfilled',       label: 'Ready',          icon: '📦' },
  { key: 'shipped',         label: 'Shipped',        icon: '🚚' },
];

const STATUS_ORDER = STATUS_STEPS.map(s => s.key);

const STATUS_LABELS = {
  pending_review:  'Pending Review',
  file_approved:   'File Approved',
  printing:        'Printing',
  post_processing: 'Post-Processing',
  fulfilled:       'Fulfilled — Shipping Soon',
  shipped:         'Shipped',
  issue_flagged:   'Action Required',
  cancelled:       'Cancelled',
};

const STATUS_MESSAGES = {
  pending_review:  "We've received your order and are reviewing your file. We'll be in touch shortly.",
  file_approved:   "Your file looks great! Your order is queued for printing.",
  printing:        "Your parts are on the printer. We'll update you when they're done.",
  post_processing: "Printing complete — your parts are being finished and quality-checked.",
  fulfilled:       "Your order has passed quality check and is being packaged for shipping.",
  shipped:         "Your order is on its way!",
  issue_flagged:   "We've found an issue with your order that needs your attention.",
  cancelled:       "This order has been cancelled.",
};

const EVENT_ICONS = {
  order_created:      '📥',
  status_changed:     '→',
  shipped:            '🚚',
  partial_shipped:    '📦',
  delivered:          '✅',
  picked_up:          '🤝',
  delivery_confirmed: '✅',
  issue_reported:     '⚠️',
  issue_resolved:     '✓',
  deadline_set:       '📅',
  outsource_sent:     '📤',
  default:            '·',
};

// ── Main ─────────────────────────────────────────────────────────────────────
const params = new URLSearchParams(location.search);
const token  = params.get('token');

document.getElementById('shop-name').textContent = window.PRINTFLOW_SHOP_NAME;
document.getElementById('contact-link').href = `mailto:${window.PRINTFLOW_CONTACT}`;

async function load() {
  try {
    if (!token) { showNoToken(); return; }

    let order, events, shipments = [], feedback = null;

    const res = await fetch(`${window.PRINTFLOW_API}/api/order?token=${encodeURIComponent(token)}`);
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${res.status}`);
    }
    const data = await res.json();
    order  = data.order;
    events = data.events || [];

    // Fetch shipments + feedback in parallel — completely silent on failure
    try {
      const [shipRes, fbRes] = await Promise.allSettled([
        fetch(`${window.PRINTFLOW_API}/api/order/${order.id}/shipments?token=${encodeURIComponent(token)}`),
        fetch(`${window.PRINTFLOW_API}/api/order/${order.id}/feedback?token=${encodeURIComponent(token)}`),
      ]);
      if (shipRes.status === 'fulfilled' && shipRes.value.ok) {
        shipments = (await shipRes.value.json()).shipments || [];
      }
      if (fbRes.status === 'fulfilled' && fbRes.value.ok) {
        feedback = (await fbRes.value.json()).feedback || null;
      }
    } catch {} // endpoints may not exist yet — degrade gracefully

    render(order, events, shipments, feedback);
  } catch (err) {
    showError(err.message);
  }
}

function render(order, events, shipments = [], feedback = null) {
  window._currentOrder = order;
  document.getElementById('header-order-num').textContent = order.shopify_order_number ? `Order #${order.shopify_order_number}` : '';

  const isIssue    = order.status === 'issue_flagged';
  const isDelivered = ['fulfilled','shipped'].includes(order.status) ||
    (shipments || []).some(s => ['delivered','picked_up'].includes(s.status));

  const showReceipt    = order.status !== 'cancelled' && order.status !== 'pending_review';
  const showReorder    = ['fulfilled','shipped'].includes(order.status) && token;
  const showQuoteBanner = ['pending_review','file_approved'].includes(order.status)
    && (order.quoted_total_price || order.shopify_total_price)
    && token;

  document.getElementById('app').innerHTML = `
    ${showReorder ? reorderBarHtml(order) : ''}
    ${showReceipt ? receiptBarHtml(token, order) : ''}
    ${showQuoteBanner ? quoteBannerHtml(order, token) : ''}
    ${isIssue ? issueBannerHtml(order) : ''}
    ${progressHtml(order)}
    ${printDetailsHtml(order)}
    ${shipmentsHtml(order, shipments)}
    ${isDelivered ? feedbackCardHtml(order, shipments, feedback) : ''}
    ${token && order.status !== 'cancelled' ? emailUpdatesHtml(order) : ''}
    ${order.shipping_address ? addressHtml(order.shipping_address) : ''}
    ${events.length ? timelineHtml(events) : ''}
  `;
}

function issueBannerHtml(order) {
  return `
    <div class="issue-banner" style="display:block;">
      <div class="title">⚠️ Action Required</div>
      <p>${esc(order.issue_description || 'There is an issue with your order. Please contact us.')}
         <br><br><a href="mailto:${window.PRINTFLOW_CONTACT}">Contact us →</a></p>
    </div>`;
}

function progressHtml(order) {
  const idx = STATUS_ORDER.indexOf(order.status);
  const stepsHtml = STATUS_STEPS.map((step, i) => {
    const done   = i < idx;
    const active = STATUS_ORDER[i] === order.status;
    const cls    = done ? 'done' : active ? 'active' : '';
    const dot    = done ? '✓' : active ? '' : '';
    return `<div class="step ${cls}">
      <div class="step-dot">${dot}</div>
      <div class="step-label">${step.label}</div>
    </div>`;
  }).join('');

  // Show live printer ETA if available (from BambuBuddy), otherwise fall back to deadline
  const deadlineNote = order.printer_eta
    ? `<div class="deadline-note">🖨️ Printing — <strong>${esc(order.printer_eta)}</strong> remaining</div>`
    : order.estimated_deadline
    ? `<div class="deadline-note">Est. completion: <strong>${fmtDate(order.estimated_deadline)}</strong></div>`
    : '';

  return `
    <div class="progress-card">
      <div class="card-title">Order Status</div>
      <div class="steps">${stepsHtml}</div>
      <div class="current-status">
        <span class="status-pill pill-${order.status}">${STATUS_LABELS[order.status] || order.status}</span>
        ${deadlineNote}
      </div>
      <p style="font-size:13px;color:var(--muted);margin-top:12px;">${STATUS_MESSAGES[order.status] || ''}</p>
    </div>`;
}

function printDetailsHtml(order) {
  const colorSwatch = order.color
    ? `<span class="color-swatch" style="background:${cssColor(order.color)};"></span>`
    : '';

  return `
    <div class="card">
      <div class="card-title">Print Details</div>
      <div class="detail-grid">
        <div class="detail-item"><div class="label">Technology</div><div class="value">${(order.technology || '—').toUpperCase()}</div></div>
        <div class="detail-item"><div class="label">Material</div><div class="value">${esc(order.material || '—')}</div></div>
        ${order.resolution ? `<div class="detail-item"><div class="label">Resolution</div><div class="value">${capitalize(order.resolution)}</div></div>` : ''}
        ${order.technology === 'fdm' && order.infill != null ? `<div class="detail-item"><div class="label">Infill</div><div class="value">${order.infill}%</div></div>` : ''}
        ${order.finish ? `<div class="detail-item"><div class="label">Finish</div><div class="value">${capitalize(order.finish)}</div></div>` : ''}
        ${order.color ? `<div class="detail-item"><div class="label">Colour</div><div class="value">${colorSwatch}${esc(order.color)}</div></div>` : ''}
        <div class="detail-item"><div class="label">Quantity</div><div class="value">${order.quantity || '—'}</div></div>
        <div class="detail-item"><div class="label">Turnaround</div><div class="value">${capitalize(order.turnaround || '—')}</div></div>
        ${order.step_file_name ? `<div class="detail-item" style="grid-column:span 2;"><div class="label">CAD File</div><div class="value" style="font-size:13px;">📎 ${esc(order.step_file_name)}</div></div>` : ''}
        ${order.quoted_total_price ? `<div class="detail-item"><div class="label">Order Total</div><div class="value">$${parseFloat(order.quoted_total_price).toFixed(2)}</div></div>` : ''}
      </div>
    </div>`;
}

// ── Shipments card ───────────────────────────────────────────────────────────
function shipmentsHtml(order, shipments) {
  if (!shipments || !shipments.length) return shippingHtml(order); // fall back to legacy

  const STATUS = { pending:'Preparing', ready:'Ready for Pickup', shipped:'Shipped', delivered:'Delivered', picked_up:'Picked Up' };
  const STATUS_COLOR = { pending:'var(--muted)', ready:'#eab308', shipped:'var(--accent)', delivered:'#16a34a', picked_up:'#16a34a' };

  const items = shipments.map((s, i) => {
    const partNames  = Array.isArray(s.part_names) && s.part_names.length ? s.part_names : ['Your order'];
    const statusColor = STATUS_COLOR[s.status] || 'var(--muted)';
    const statusLabel = STATUS[s.status] || s.status;
    const isPickup   = s.method === 'local_pickup';

    let trackBtn = '';
    if (s.tracking_number && !isPickup) {
      const url = getTrackingUrl(s.carrier, s.tracking_number);
      trackBtn = `<a href="${url}" target="_blank" rel="noopener"
        style="background:var(--accent);color:#fff;padding:7px 14px;border-radius:6px;
               font-size:12px;font-weight:700;text-decoration:none;display:inline-block;margin-top:10px;">
        Track Package →
      </a>`;
    }

    const deliveryLine = s.estimated_delivery_at
      ? `<div style="font-size:12px;color:var(--muted);margin-top:4px;">
           Est. delivery: <strong style="color:var(--text);">${new Date(s.estimated_delivery_at).toLocaleDateString('en-CA',{weekday:'short',month:'short',day:'numeric'})}</strong>
         </div>` : '';

    const deliveredLine = s.delivered_at
      ? `<div style="font-size:12px;color:#16a34a;margin-top:4px;">
           ✓ ${isPickup ? 'Picked up' : 'Delivered'} ${new Date(s.delivered_at).toLocaleDateString('en-CA',{month:'short',day:'numeric'})}
         </div>` : '';

    const trackingLine = s.tracking_number && !isPickup
      ? `<div style="margin-top:8px;">
           <div style="font-size:10px;color:var(--muted);font-weight:700;text-transform:uppercase;letter-spacing:.06em;">Tracking</div>
           <div style="font-family:'SF Mono','Fira Code',monospace;font-size:13px;font-weight:700;color:var(--accent);margin-top:2px;">${esc(s.tracking_number)}</div>
           ${s.carrier ? `<div style="font-size:11px;color:var(--muted);">${esc(s.carrier)}</div>` : ''}
         </div>` : '';

    return `<div class="shipment-item">
      <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">
        <div>
          <div style="font-size:13px;font-weight:600;">${shipments.length > 1 ? `Shipment ${i+1} — ` : ''}${partNames.map(n=>esc(n)).join(', ')}</div>
          <div style="font-size:11px;color:${statusColor};font-weight:700;margin-top:3px;">
            ${isPickup ? '📍' : '🚚'} ${statusLabel}
          </div>
        </div>
      </div>
      ${trackingLine}${deliveryLine}${deliveredLine}${trackBtn}
    </div>`;
  }).join('');

  return `
    <div class="card">
      <div class="card-title">${shipments.length > 1 ? 'Shipments' : 'Shipping'}</div>
      ${items}
    </div>`;
}

// ── Delivery feedback card ────────────────────────────────────────────────────
function feedbackCardHtml(order, shipments, existing) {
  const deliveredShipment = (shipments || []).find(s => ['delivered','picked_up'].includes(s.status));
  const shipmentId = deliveredShipment?.id || '';
  const isPickup   = deliveredShipment?.method === 'local_pickup' || order.shipping_method === 'local_pickup';

  // Already submitted
  if (existing) {
    if (existing.outcome === 'good') {
      return `<div class="card feedback-card feedback-good">
        <div style="font-size:22px;margin-bottom:8px;">✅</div>
        <div style="font-weight:700;font-size:14px;color:#15803d;">Parts confirmed — all good!</div>
        <div style="font-size:12px;color:var(--muted);margin-top:4px;">Thanks for letting us know your order arrived in great shape.</div>
      </div>`;
    }
    if (existing.outcome === 'issue') {
      const responseSection = existing.admin_response ? `
        <div style="margin-top:12px;background:rgba(255,255,255,.5);border-radius:8px;padding:12px;">
          <div style="font-size:11px;font-weight:700;color:#b91c1c;margin-bottom:4px;">Our Response</div>
          <div style="font-size:13px;">${esc(existing.admin_response)}</div>
          ${existing.resolution ? `<div style="font-size:11px;color:var(--muted);margin-top:4px;">Resolution: ${esc(existing.resolution)}</div>` : ''}
        </div>` : `<div style="font-size:12px;color:var(--muted);margin-top:8px;">We've received your report and will be in touch shortly.</div>`;
      return `<div class="card feedback-card feedback-issue">
        <div style="font-size:22px;margin-bottom:8px;">⚠️</div>
        <div style="font-weight:700;font-size:14px;color:#b91c1c;">Issue reported</div>
        ${existing.issue_type ? `<div style="font-size:12px;color:var(--muted);margin-top:4px;">${esc(existing.description || '')}</div>` : ''}
        ${responseSection}
      </div>`;
    }
  }

  // Not submitted yet
  const prompt = isPickup
    ? 'How did your pickup go? Did everything look right?'
    : 'Did your parts arrive in good condition?';

  return `
  <div class="card feedback-card feedback-pending" id="feedback-card"
    data-fb-token="${token || ''}" data-fb-ship="${shipmentId}">
    <div style="font-size:22px;margin-bottom:10px;">📦</div>
    <div style="font-weight:700;font-size:15px;">${prompt}</div>
    <div style="font-size:13px;color:var(--muted);margin-top:6px;line-height:1.6;">Let us know how things turned out — it takes 5 seconds.</div>

    <div class="feedback-btn-row" id="fb-choice">
      <button class="fb-btn-good"  onclick="fbGood()">✅ All Good!</button>
      <button class="fb-btn-issue" onclick="fbShowIssue()">⚠️ I Have an Issue</button>
    </div>

    <div class="fb-issue-form" id="fb-issue-form">
      <select class="fb-select" id="fb-issue-type">
        <option value="">— What's the issue? —</option>
        <option value="wrong_dimensions">Wrong dimensions / doesn't fit</option>
        <option value="print_failed">Print failed or incomplete</option>
        <option value="damaged">Damaged in shipping</option>
        <option value="wrong_material">Wrong material or colour</option>
        <option value="wrong_quantity">Wrong quantity</option>
        <option value="surface_finish">Surface finish / layer lines</option>
        <option value="support_marks">Support marks / scarring</option>
        <option value="other">Other</option>
      </select>
      <textarea class="fb-textarea" id="fb-desc" rows="3"
        placeholder="Optional: tell us more so we can sort it out quickly…"></textarea>
      <button class="fb-submit" onclick="fbSubmitIssue()">Send Issue Report</button>
      <p class="fb-back" onclick="fbHideIssue()">← Back</p>
    </div>

    <div id="fb-thanks" style="display:none;text-align:center;padding:10px 0;">
      <div style="font-size:32px;margin-bottom:8px;" id="fb-thanks-icon">✅</div>
      <div style="font-weight:700;font-size:15px;" id="fb-thanks-title">Thanks!</div>
      <div style="font-size:13px;color:var(--muted);margin-top:6px;" id="fb-thanks-body"></div>
    </div>
  </div>`;
}

// Carrier → tracking URL map
const CARRIER_URLS = {
  ups:      n => `https://www.ups.com/track?tracknum=${n}`,
  fedex:    n => `https://www.fedex.com/fedextrack/?trknbr=${n}`,
  canada_post: n => `https://www.canadapost-postescanada.ca/track-reperage/en#/search?searchFor=${n}`,
  purolator:n => `https://eshiponline.purolator.com/ShipOnline/Public/Track/TrackingDetails.aspx?pin=${n}`,
  canpar:   n => `https://www.canpar.com/en/parcel-tracking/track-my-parcel.page?locale=en&reference=${n}`,
  dhl:      n => `https://www.dhl.com/us-en/home/tracking.html?tracking-id=${n}`,
  usps:     n => `https://tools.usps.com/go/TrackConfirmAction?tLabels=${n}`,
};

function getTrackingUrl(carrier, number) {
  const c = (carrier || '').toLowerCase().replace(/[\s-]/g, '_');
  const fn = CARRIER_URLS[c];
  return fn ? fn(number) : `https://www.google.com/search?q=${encodeURIComponent(carrier+' '+number+' tracking')}`;
}

function shippingHtml(order) {
  const isShipped  = order.status === 'shipped';
  const hasTracking = !!(order.tracking_number);
  const isPickup   = order.shipping_method === 'local_pickup';
  const isLocalDel = order.shipping_method === 'local_delivery';

  // Local pickup — no shipping card needed
  if (isPickup) return '';

  // Not shipped yet — nothing to show
  if (!isShipped && !hasTracking) return '';

  if (!hasTracking) {
    // Shipped status but no label yet
    return `
      <div class="card">
        <div class="card-title">Shipping</div>
        <div style="display:flex;align-items:center;gap:12px;background:var(--surface2);border-radius:8px;padding:14px 16px;">
          <div style="font-size:22px;">🏷️</div>
          <div>
            <div style="font-weight:600;font-size:14px;">Label not purchased yet</div>
            <div style="font-size:12px;color:var(--muted);margin-top:3px;">
              ${isLocalDel
                ? 'Delivery is being arranged — tracking will appear here once booked.'
                : 'Your shipping label is being prepared. Tracking will appear here as soon as it\'s purchased.'}
            </div>
          </div>
        </div>
      </div>`;
  }

  // Has tracking number — show it with link
  const trackUrl = getTrackingUrl(order.shipping_carrier, order.tracking_number);
  const carrierLabel = order.shipping_carrier
    ? order.shipping_carrier.replace(/_/g,' ').replace(/\b\w/g,c=>c.toUpperCase())
    : null;

  return `
    <div class="card">
      <div class="card-title">Shipping</div>
      <div class="tracking-block">
        <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;">
          <div>
            <div style="font-size:11px;color:var(--muted);margin-bottom:4px;font-weight:600;text-transform:uppercase;letter-spacing:.06em;">Tracking Number</div>
            <div class="tracking-num">${esc(order.tracking_number)}</div>
            ${carrierLabel ? `<div class="carrier">${esc(carrierLabel)}</div>` : ''}
          </div>
          <a href="${trackUrl}" target="_blank" rel="noopener"
            style="background:var(--accent);color:#fff;padding:9px 18px;border-radius:8px;
                   font-size:13px;font-weight:700;text-decoration:none;white-space:nowrap;flex-shrink:0;">
            Track Package →
          </a>
        </div>
        ${order.shipped_at ? `<div style="font-size:11px;color:var(--muted);margin-top:10px;padding-top:10px;border-top:1px solid var(--border);">Shipped ${fmtDateTime(order.shipped_at)}</div>` : ''}
      </div>
    </div>`;
}

// ── Email updates card ───────────────────────────────────────────────────────
const MAX_CC = 3;

function emailUpdatesHtml(order) {
  const list = Array.isArray(order.cc_emails) ? order.cc_emails : [];
  const rows = list.map(e => `
    <div class="cc-row">
      <span class="cc-email">📧 ${esc(e)}</span>
      <button class="cc-remove" onclick="ccRemove('${esc(e)}')" title="Stop updates for this address">✕</button>
    </div>`).join('');

  return `
    <div class="card" id="cc-card">
      <div class="card-title">Email Updates</div>
      <p class="cc-hint">Want someone else to follow this order? Add their email below and they'll receive every update we send — quote, printing, shipping, the works.</p>
      <div id="cc-list">${rows}</div>
      ${list.length < MAX_CC ? `
      <div class="cc-add-row">
        <input type="email" id="cc-input" placeholder="name@example.com" autocomplete="off"
               onkeydown="if(event.key==='Enter'){event.preventDefault();ccAdd();}">
        <button class="cc-add-btn" id="cc-add-btn" onclick="ccAdd()">Add</button>
      </div>` : `<p class="cc-hint" style="margin:0;">Maximum of ${MAX_CC} extra addresses reached — remove one to add another.</p>`}
      <p class="cc-msg" id="cc-msg"></p>
    </div>`;
}

function refreshCcCard() {
  const card = document.getElementById('cc-card');
  if (card) card.outerHTML = emailUpdatesHtml(window._currentOrder);
}

async function ccPost(path, email) {
  const res = await fetch(`${window.PRINTFLOW_API}/api/order/${path}?token=${encodeURIComponent(token)}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Something went wrong — please try again');
  return data;
}

async function ccAdd() {
  const input = document.getElementById('cc-input');
  const btn   = document.getElementById('cc-add-btn');
  const msg   = document.getElementById('cc-msg');
  const email = (input?.value || '').trim();
  if (!email) return;
  if (btn) { btn.disabled = true; btn.textContent = '…'; }
  if (msg) { msg.textContent = ''; msg.className = 'cc-msg'; }
  try {
    const data = await ccPost('cc-email', email);
    window._currentOrder.cc_emails = data.cc_emails;
    refreshCcCard();
    const newMsg = document.getElementById('cc-msg');
    if (newMsg) { newMsg.textContent = `✓ ${email} will now get every order update.`; newMsg.className = 'cc-msg cc-msg-ok'; }
  } catch (err) {
    if (msg) { msg.textContent = err.message; msg.className = 'cc-msg cc-msg-err'; }
    if (btn) { btn.disabled = false; btn.textContent = 'Add'; }
  }
}

async function ccRemove(email) {
  try {
    const data = await ccPost('cc-email/remove', email);
    window._currentOrder.cc_emails = data.cc_emails;
    refreshCcCard();
  } catch (err) {
    const msg = document.getElementById('cc-msg');
    if (msg) { msg.textContent = err.message; msg.className = 'cc-msg cc-msg-err'; }
  }
}

function addressHtml(addr) {
  const lines = [
    addr.name,
    addr.address1 + (addr.address2 ? ', ' + addr.address2 : ''),
    `${addr.city}, ${addr.province_code || addr.province} ${addr.zip}`,
    addr.country,
  ].filter(Boolean);
  return `
    <div class="card">
      <div class="card-title">Shipping Address</div>
      <div class="address-block">${lines.map(esc).join('<br>')}</div>
    </div>`;
}

function timelineHtml(events) {
  const items = [...events].reverse().map(e => {
    const icon = EVENT_ICONS[e.event_type] || EVENT_ICONS.default;
    return `<li>
      <div class="tl-icon">${icon}</div>
      <div class="tl-body">
        <div class="tl-desc">${esc(e.description || e.event_type)}</div>
        <div class="tl-time">${fmtDateTime(e.created_at)}</div>
      </div>
    </li>`;
  }).join('');
  return `
    <div class="card">
      <div class="card-title">Order Timeline</div>
      <ul class="timeline">${items}</ul>
    </div>`;
}

function quoteBannerHtml(order, tok) {
  const price = parseFloat(order.quoted_total_price || order.shopify_total_price || 0);
  const alreadyApproved = order.status === 'file_approved';
  return `
    <div class="quote-banner">
      <div class="qb-header">
        <span style="font-size:22px;">💬</span>
        <span class="qb-title">${alreadyApproved ? 'Quote Approved' : 'Your Quote is Ready'}</span>
      </div>
      ${alreadyApproved
        ? `<div style="font-size:13px;color:var(--green);font-weight:600;margin:8px 0 4px;">✓ You've approved this quote — we'll be in touch shortly.</div>`
        : `<div class="qb-price">$${price.toFixed(2)} <span style="font-size:14px;font-weight:500;color:var(--muted);">CAD</span></div>
           <div class="qb-sub">
             Review your quote below. Once you approve, we'll get started on your print.<br>
             If anything doesn't look right, you can decline and let us know why.
           </div>
           <div class="qb-btns">
             <button class="btn-approve" id="btn-approve" onclick="approveQuote('${encodeURIComponent(tok)}')">
               ✓ Approve Quote
             </button>
             <button class="btn-decline" id="btn-decline" onclick="showDeclineReason()">
               ✗ Decline
             </button>
           </div>
           <div class="decline-reason-box" id="decline-reason-box">
             <div style="font-size:12px;font-weight:600;color:var(--red);margin-bottom:8px;">Let us know why (optional — helps us improve)</div>
             <textarea id="decline-reason-input" placeholder="e.g. Price is a bit higher than expected, or I found a local option…"></textarea>
             <div style="display:flex;gap:8px;">
               <button class="btn-decline" onclick="submitDecline('${encodeURIComponent(tok)}')">Confirm Decline</button>
               <button onclick="hideDeclineReason()"
                 style="border:none;background:none;color:var(--muted);font-size:13px;cursor:pointer;padding:8px;">Cancel</button>
             </div>
           </div>`
      }
    </div>`;
}

async function approveQuote(encodedToken) {
  const tok = decodeURIComponent(encodedToken);
  const btn = document.getElementById('btn-approve');
  const decBtn = document.getElementById('btn-decline');
  if (btn) { btn.disabled = true; btn.textContent = 'Approving…'; }
  if (decBtn) decBtn.disabled = true;
  try {
    const res = await fetch(`${window.PRINTFLOW_API}/api/order/approve-quote?token=${encodeURIComponent(tok)}`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
    // Reload to show updated status
    load();
  } catch (err) {
    if (btn) { btn.disabled = false; btn.textContent = '✓ Approve Quote'; }
    if (decBtn) decBtn.disabled = false;
    alert('Could not approve: ' + err.message);
  }
}

function showDeclineReason() {
  const box = document.getElementById('decline-reason-box');
  if (box) { box.style.display = 'block'; box.querySelector('textarea')?.focus(); }
}
function hideDeclineReason() {
  const box = document.getElementById('decline-reason-box');
  if (box) box.style.display = 'none';
}

async function submitDecline(encodedToken) {
  const tok    = decodeURIComponent(encodedToken);
  const reason = document.getElementById('decline-reason-input')?.value?.trim() || '';
  const btn    = document.querySelector('.decline-reason-box .btn-decline');
  if (btn) { btn.disabled = true; btn.textContent = 'Declining…'; }
  try {
    const res = await fetch(`${window.PRINTFLOW_API}/api/order/decline-quote?token=${encodeURIComponent(tok)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ reason }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
    load();
  } catch (err) {
    if (btn) { btn.disabled = false; btn.textContent = 'Confirm Decline'; }
    alert('Could not decline: ' + err.message);
  }
}

function reorderBarHtml(order) {
  // Build query params from the order's parts
  const parts = Array.isArray(order.parts_json) && order.parts_json.length
    ? order.parts_json
    : [{ tech: order.technology, material: order.material, finish: order.finish, color: order.color, qty: order.quantity }];

  const p = parts[0] || {};
  const qs = new URLSearchParams({
    reorder:  '1',
    tech:     p.tech      || order.technology || 'fdm',
    material: p.material  || order.material   || '',
    finish:   p.finish    || order.finish      || 'raw',
    color:    p.color     || order.color       || '',
    qty:      p.qty       || order.quantity    || 1,
    infill:   p.infill    || 20,
    layer:    p.layer     || 0.2,
    from_order: order.shopify_order_number || '',
  });

  const url = `${window.PRINTFLOW_QUOTE_URL}?${qs}`;

  return `
    <div style="background:rgba(37,99,235,.06);border:1px solid rgba(37,99,235,.2);border-radius:10px;
                padding:14px 18px;margin-bottom:16px;display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;">
      <div>
        <div style="font-weight:700;font-size:14px;color:var(--text);">Need another one?</div>
        <div style="font-size:12px;color:var(--muted);margin-top:2px;">Reorder with the same settings — no re-uploading needed.</div>
      </div>
      <a href="${url}" style="background:var(--accent);color:#fff;padding:10px 20px;border-radius:8px;
         font-size:13px;font-weight:700;text-decoration:none;white-space:nowrap;flex-shrink:0;">
        🔄 Reorder
      </a>
    </div>`;
}

function receiptBarHtml(tok, order) {
  const emailBtn = `<button class="receipt-btn" onclick="openEmailModal()">📧 Email Receipt</button>`;
  const receiptUrl = `${window.PRINTFLOW_API}/api/order/receipt?token=${encodeURIComponent(tok)}`;
  const invoiceUrl = `${window.PRINTFLOW_API}/api/order/invoice?token=${encodeURIComponent(tok)}`;
  return `
    <div class="receipt-bar">
      ${emailBtn}
      <a class="receipt-btn" href="${receiptUrl}" target="_blank" rel="noopener">🧾 Receipt</a>
      <a class="receipt-btn" href="${invoiceUrl}" target="_blank" rel="noopener">📄 HST Invoice</a>
    </div>`;
}

function showNoToken() {
  document.getElementById('app').innerHTML = `
    <div class="state-box">
      <div class="icon">🔎</div>
      <h2>Track your order</h2>
      <p>To view your order status, use the secure tracking link in your order confirmation email.<br>
         Can't find it? We're happy to resend it.</p>
      <p style="margin-top:16px;"><a href="mailto:${window.PRINTFLOW_CONTACT}" style="color:var(--accent);font-weight:600;">Contact us →</a></p>
    </div>`;
}

function showError(msg) {
  const friendly = msg.includes('Invalid') || msg.includes('expired')
    ? { icon: '🔐', title: 'Link not valid', body: 'This order link is invalid or has expired. Check your email for the correct link.' }
    : msg.includes('Not found')
    ? { icon: '📭', title: 'Order not found', body: 'We couldn\'t find this order. Please contact us if you think this is a mistake.' }
    : { icon: '⚠️', title: 'Something went wrong', body: `Could not load your order. (${msg})` };

  document.getElementById('app').innerHTML = `
    <div class="state-box">
      <div class="icon">${friendly.icon}</div>
      <h2>${friendly.title}</h2>
      <p>${friendly.body}</p>
      <p style="margin-top:16px;"><a href="mailto:${window.PRINTFLOW_CONTACT}" style="color:var(--accent);font-weight:600;">Contact us →</a></p>
    </div>`;
}

// ── Utilities ────────────────────────────────────────────────────────────────
function esc(s) {
  return String(s ?? '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

function capitalize(s) {
  return String(s ?? '').replace(/_/g,' ').replace(/\b\w/g, c => c.toUpperCase());
}

function fmtDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-CA', { weekday:'long', month:'long', day:'numeric' });
}

function fmtDateTime(d) {
  if (!d) return '—';
  return new Date(d).toLocaleString('en-CA', { month:'short', day:'numeric', year:'numeric', hour:'2-digit', minute:'2-digit' });
}

// Map common colour names to approximate CSS colours for the swatch
function cssColor(name) {
  const map = {
    black:'#1a1a1a', white:'#f5f5f5', red:'#ef4444', blue:'#3b82f6',
    green:'#22c55e', yellow:'#eab308', orange:'#f97316', purple:'#a855f7',
    pink:'#ec4899', grey:'#9ca3af', gray:'#9ca3af', silver:'#cbd5e1',
    'matte black':'#27272a', 'matte white':'#e4e4e7',
    'translucent':'rgba(200,200,220,0.5)',
  };
  return map[name?.toLowerCase()] || '#a1a1aa';
}

// ── Email Receipt Modal ───────────────────────────────────────────────────────
function openEmailModal() {
  const modal = document.getElementById('email-receipt-modal');
  const input = document.getElementById('email-receipt-input');
  const status = document.getElementById('email-receipt-status');
  // Pre-fill with customer email if available
  input.value = window._currentOrder?.customer_email || '';
  status.textContent = '';
  document.getElementById('email-receipt-send-btn').disabled = false;
  modal.classList.add('open');
  setTimeout(() => input.focus(), 50);
}

function closeEmailModal() {
  document.getElementById('email-receipt-modal').classList.remove('open');
}

async function sendReceiptEmail() {
  const input  = document.getElementById('email-receipt-input');
  const btn    = document.getElementById('email-receipt-send-btn');
  const status = document.getElementById('email-receipt-status');
  const email  = input.value.trim();

  if (!email || !email.includes('@')) {
    status.style.color = 'var(--red)';
    status.textContent = 'Please enter a valid email address.';
    return;
  }

  btn.disabled = true;
  status.style.color = 'var(--muted)';
  status.textContent = 'Sending…';

  try {
    const res = await fetch(
      `${window.PRINTFLOW_API}/api/order/email-receipt?token=${encodeURIComponent(token)}`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      }
    );
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
    status.style.color = 'var(--green)';
    status.textContent = `✓ Receipt sent to ${data.sent_to}`;
    setTimeout(closeEmailModal, 2000);
  } catch (err) {
    status.style.color = 'var(--red)';
    status.textContent = `Failed: ${err.message}`;
    btn.disabled = false;
  }
}

// Close modal on overlay click
document.addEventListener('click', e => {
  if (e.target.id === 'email-receipt-modal') closeEmailModal();
});

// ── Go ───────────────────────────────────────────────────────────────────────
load();

// ── Delivery feedback actions ────────────────────────────────────────────────
function _fbCard()  { return document.getElementById('feedback-card'); }
function _fbToken() { return _fbCard()?.dataset?.fbToken || token || ''; }
function _fbShip()  { return _fbCard()?.dataset?.fbShip  || ''; }

async function fbPost(body) {
  try {
    await fetch(`${window.PRINTFLOW_API}/api/delivery/feedback`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: _fbToken(), shipment_id: _fbShip(), ...body }),
    });
  } catch {} // silent fail — don't block the UI
}

async function fbGood() {
  document.getElementById('fb-choice').style.display = 'none';
  await fbPost({ outcome: 'good' });
  document.getElementById('fb-thanks').style.display = 'block';
  document.getElementById('fb-thanks-icon').textContent  = '✅';
  document.getElementById('fb-thanks-title').textContent = 'Great to hear!';
  document.getElementById('fb-thanks-body').textContent  = "Thanks for letting us know — we really appreciate it.";
  _fbCard().className = 'card feedback-card feedback-good';
}

function fbShowIssue() {
  document.getElementById('fb-choice').style.display     = 'none';
  document.getElementById('fb-issue-form').style.display = 'block';
}

function fbHideIssue() {
  document.getElementById('fb-issue-form').style.display = 'none';
  document.getElementById('fb-choice').style.display     = 'grid';
}

async function fbSubmitIssue() {
  const type = document.getElementById('fb-issue-type').value;
  const desc = document.getElementById('fb-desc').value.trim();
  if (!type) { alert('Please select an issue type'); return; }
  document.getElementById('fb-issue-form').style.display = 'none';
  await fbPost({ outcome: 'issue', issue_type: type, description: desc });
  document.getElementById('fb-thanks').style.display = 'block';
  document.getElementById('fb-thanks-icon').textContent  = '🙏';
  document.getElementById('fb-thanks-title').textContent = "We're on it.";
  document.getElementById('fb-thanks-body').textContent  = "We've received your report and will be in touch shortly to make it right.";
  _fbCard().className = 'card feedback-card feedback-issue';
}

// Expose handlers used by inline onclick attributes in rendered HTML
window.approveQuote      = approveQuote;
window.showDeclineReason = showDeclineReason;
window.hideDeclineReason = hideDeclineReason;
window.submitDecline     = submitDecline;
window.openEmailModal    = openEmailModal;
window.closeEmailModal   = closeEmailModal;
window.sendReceiptEmail  = sendReceiptEmail;
window.fbGood            = fbGood;
window.fbShowIssue       = fbShowIssue;
window.fbHideIssue       = fbHideIssue;
window.fbSubmitIssue     = fbSubmitIssue;
window.ccAdd             = ccAdd;
window.ccRemove          = ccRemove;

})();
